import { render, staticRenderFns } from "./AddInfo.vue?vue&type=template&id=a029f858&scoped=true"
import script from "./AddInfo.vue?vue&type=script&lang=js"
export * from "./AddInfo.vue?vue&type=script&lang=js"
import style0 from "./AddInfo.vue?vue&type=style&index=0&id=a029f858&prod&scoped=true&lang=css"
import style1 from "./AddInfo.vue?vue&type=style&index=1&id=a029f858&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a029f858",
  null
  
)

export default component.exports